<template>
  <a-modal
    :visible="true"
    width="600px"
    title="导入数据"
    @ok="onSubmitEvent"
    :ok-button-props="{ loading: onSubmitLoading }"
    @cancel="onCancel"
    ok-text="提交"
    cancel-text="关闭"
    destroyOnClose
  >
    <a-upload
      :file-list="fileList"
      :before-upload="beforeUpload"
      accept=".xls,.xlsx"
      @remove="handleRemove"
      :max-count="1"
      :multiple="false"
    >
      <a-space>
        <a-button style="display: block">选取文件</a-button>
        <a href="javascript:;" @click.stop="templateDownload">模板下载</a>
      </a-space>
    </a-upload>
  </a-modal>
</template>
<script>
export default {
  name: 'ImportEmployeeDataDialog.vue',
  props: {
    enterpriseId: {
      type: Number | String,
      default: ''
    }
  },
  data() {
    return {
      onSubmitLoading: false,
      fileObj: undefined,
      fileList: []
    }
  },
  methods: {
    beforeUpload(file) {
      this.fileList = [file]
      this.fileObj = file
      return false
    },
    // 不要依赖beforeUpload存文件，优先在change拿originFileObj
    handleUploadChange(info) {
      // 单文件，只保留最新那一条，强制回写fileList，覆盖组件内部状态
      this.fileList = info.fileList.slice(-1)
      if (this.fileList.length > 0) {
        // 原生浏览器File对象，一定要取 originFileObj
        this.fileObj = this.fileList[0].originFileObj
      } else {
        this.fileObj = undefined
      }
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = []
      this.fileObj = undefined
    },
    onCancel() {
      this.$emit('cancel')
    },
    templateDownload() {
      window.open('https://imgb.woyoubooking.com/config/批量导入员工模板.xls')
    },
    onSubmitEvent() {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.error('请选择文件')
        return false
      }
      const headers = {
        'Content-Type': 'multipart/form-data'
      }
      this.onSubmitLoading = true
      const file = this.fileObj
      const formData = new FormData()
      formData.append('file', file)
      formData.append('enterpriseId', this.enterpriseId)
      this.getHttpServices().getMemberAuthService().post(`member/v3/auth/employee/import/${this.enterpriseId}`, formData, headers)
        .then(res => {
          console.error(res)
          this.onCancel()
          this.$emit('ok')
        })
        .catch(error => {
          if (error.msg) {
            this.$message.error(error.msg)
          }
          console.error(error)
        })
    }
  }
}
</script>
<style scoped lang="less">
.tips {
  margin: 24px 0;
}

</style>